// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@rpsc/App/SharedStyles/CartLineSharedStyles";
import { cartLinesListHeaderStyles } from "@rpsc/Overrides/Components/CartLinesListHeader";
import { requestRmaProductListStyles } from "@rpsc/Overrides/Widgets/RequestRma/RequestRmaProductList";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

requestRmaProductListStyles.productTotalPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceHeadingAndText,
};

requestRmaProductListStyles.productBrandStyles = {
    ...cartLineSharedStyles.productBrand,
};

requestRmaProductListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

requestRmaProductListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

requestRmaProductListStyles.returnReasonSelect = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            width: auto;
            margin-top: 10px;
        `,
        formInputWrapper: css`
            max-width: 225px;
            width: 225px;
            ${xScreen("lte", "xs")} {
                max-width: 100%;
            }
        `,
    },
};

requestRmaProductListStyles.qtyToReturnTextField = {
    cssOverrides: {
        formField: css`
            width: 100px;
            margin-right: auto;
            ${xScreen("lte", "xs")} {
                margin-right: 0;
            }
        `,
        formInputWrapper: css`
            width: 90px;
        `,
    },
};

requestRmaProductListStyles.gridContainer = {
    css: css`
        margin-bottom: 25px;
        ${xScreen("lte", "md")} {
            width: 100%;
            max-width: 500px;
        }
    `,
};

requestRmaProductListStyles.cartLineContainerStyles = {
    actions: {
        css: css`
            grid-column: 5 / 8;
            justify-content: end;
            ${xScreen("lte", "md")} {
                justify-content: start;
            }
        `,
    },
    price: {
        ...mergeWithCss(requestRmaProductListStyles.cartLineContainerStyles?.price, {
            css: css`
                line-height: 19px;
            `,
        }),
    },
};

requestRmaProductListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceHeadingAndText?.extendedStyles?.heading,
};

requestRmaProductListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceHeadingAndText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
            line-height: 19px;
        `,
    }),
};

requestRmaProductListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: ${fontConfig.lineHeight.small};
            margin-left: 4px;
        `,
    }),
};

requestRmaProductListStyles.orderLineCardImage = {
    css: css`
        ${cartLineSharedStyles?.productImage?.linkWrappingImage?.css}
    `,
};

requestRmaProductListStyles.linesListHeader = {
    wrapper: {
        ...mergeWithCss(cartLinesListHeaderStyles.wrapper, {
            css: css`
                border-top: none;
            `,
        }),
    },
};
